import type { GroupWithMeta, RenderableItem } from "../events/messageGroups"
import { isActivityDigestItem } from "./activityDigestModel"

export function groupByRenderMode(groups: GroupWithMeta[]): RenderableItem[] {
    const result: RenderableItem[] = []
    let pillBuffer: GroupWithMeta[] = []
    let activityBuffer: GroupWithMeta[] = []

    const flushPills = () => {
        if (pillBuffer.length > 0) {
            result.push({ mode: "pill", items: [...pillBuffer] })
            pillBuffer = []
        }
    }

    const flushActivities = () => {
        if (activityBuffer.length > 0) {
            result.push({ mode: "activityDigest", items: [...activityBuffer] })
            activityBuffer = []
        }
    }

    for (const g of groups) {
        if (isActivityDigestItem(g)) {
            flushPills()
            activityBuffer.push(g)
            continue
        }
        flushActivities()
        if (g.mode === "pill") {
            pillBuffer.push(g)
        } else {
            flushPills()
            result.push({ mode: g.mode, item: g })
        }
    }
    flushActivities()
    flushPills()

    return result
}
